<template>
  <div class="map">
    <el-input
      v-model="addressKeyword"
      placeholder="请输入地址来直接查找相关位置"
      clearable
      style="margin-bottom:20px"
      @keyup.enter.native="setPlace(addressKeyword)"
    >
      <el-button
        slot="append"
        icon="el-icon-search"
        @click="setPlace(addressKeyword)"
      ></el-button>
    </el-input>
    <div id="container" style="width:100%; height:300px"></div>
    <p>{{ "经度：" + (shopInfo.lng || "") }}</p>
    <p>{{ "纬度：" + (shopInfo.lat || "") }}</p>
    <p>{{ "地址：" + (address || addressKeyword || "") }}</p>
  </div>
</template>

<script>
import $ from "jquery";

import { BMPGL } from "./bmpgl.js";
export default {
  props: ["inputName"],
  data() {
    return {
      addressKeyword: "",
      map: null,
      getAddCode: null,
      heighted: 380,
      marker: "",
      address: "",
      pointLists: [],
      shopInfo: {
        lng: "",
        lat: "",
      },
      ak: "S6zkx4nmO3Hmp75L8SweEdAEYvvyK8GG",
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    setPlace(value) {
      //智能搜索
      var vue = this;
      var local,
        point,
        marker = null;
      local = new BMapGL.LocalSearch(this.map, {
        //智能搜索
        onSearchComplete: fn,
      });
      local.search(value);
      function fn() {
        //如果搜索的有结果
        if (local.getResults() != undefined) {
          vue.map.clearOverlays(); //清除地图上所有覆盖物
          if (local.getResults().getPoi(0)) {
            point = local.getResults().getPoi(0).point; //获取第一个智能搜索的结果
            vue.map.centerAndZoom(point, 18);
            vue.shopInfo = point;
            vue.getAddressCode();
            // this.marker = new BMapGL.Marker(point); // 创建标注
            // vue.map.addOverlay(marker); // 将标注添加到地图中
            // marker.enableDragging(); // 可拖拽
          } else {
            vue.$message("未匹配到地点!可拖动地图上的红色图标到精确位置");
          }
        } else {
          vue.$message("未找到搜索结果");
        }
      }
    },

    //func: 是父组件指定的传数据绑定的函数，this.msg:子组件给父组件传递的数据
    sendMsg() {
      var d = {
        lng: this.shopInfo.lng,
        lat: this.shopInfo.lat,
        city: this.addressKeyword,
      };
      this.$emit("func", d);
    },
    // 通过坐标获得地址
    getAddressCode() {
      if (this.marker) {
        this.map.removeOverlay(this.marker);
      }
      this.marker = new BMapGL.Marker(this.shopInfo);
      this.map.addOverlay(this.marker);
      this.marker.enableDragging(); // 可拖拽

      var geoc = new BMapGL.Geocoder(); //地址解析对象
      geoc.getLocation(this.shopInfo, (rs) => {
        if (rs) {
          this.address = rs.address;
        }
      });
      this.marker.addEventListener("click", (clikcEvent) => {
        console.log(clikcEvent);
        //跳转到连接中带的位置，默认是usePowerUnit
        // this.$router.push("/usePowerUnit")
      });
    },

    init() {
      // this.map = new BMapGL.Map('container', {
      //   mapType: BMAP_NORMAL_MAP,
      //   enableMapClick: false
      // });
      BMPGL(this.ak).then((BMapGL) => {
        this.map = new BMapGL.Map("container");
        var d = this.inputName ? this.inputName.split(",") : [];
        var lng = d[0] || 116.404;
        var lat = d[1] || 39.915;
        (this.shopInfo = new BMapGL.Point(lng, lat)),
          this.map.centerAndZoom(this.shopInfo, 11);
        this.map.setHeading(64.5); //设置地图旋转角度
        this.map.setTilt(73); //设置地图的倾斜角度
        this.map.addControl(
          new BMapGL.MapTypeControl({
            mapTypes: [BMAP_HYBRID_MAP, BMAP_NORMAL_MAP],
          })
        );
        this.map.enableScrollWheelZoom(true);
        this.map.setMapType(BMAP_EARTH_MAP);
        this.getAddressCode();

        this.map.addEventListener("click", (clikcEvent) => {
          this.shopInfo = clikcEvent.latlng;
          this.getAddressCode();

          //跳转到连接中带的位置，默认是usePowerUnit
          // this.$router.push("/usePowerUnit")
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
#container {
  /*地图(容器)显示大小*/
  width: 1200px;
  height: 400px;
}

p {
  margin: 0;
}
</style>
